import "@pjs/theming/dist/theme.css";
import { injectCss } from "../../../../../../node_modules/@pebblepad/pebblepack/runtime/InjectCss.runtime.js";
injectCss(`.cui-dialog-backdrop{z-index:298;background-color:#383a4280;position:fixed;inset:0}`);